// eslint-disable-next-line
const style = (theme, scale = 1) => {
  return {
    appBar: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      minHeight: "68px",
      background: "var(--tezex-header)",
      borderBottom: "1px solid var(--tezex-line-soft)",
      backdropFilter: "blur(16px)",
      "&.MuiPaper-root": {
        boxShadow: "none",
      },
      "@media (min-width: 1200px)": { minHeight: "76px" },
      mobile: {
        minHeight: "68px",
        background: "var(--tezex-header)",
        borderBottom: "1px solid var(--tezex-line-soft)",
        "&.MuiPaper-root": {
          boxShadow: "none",
        },
      },
    },
    shell: {
      maxWidth: "1180px",
      padding: "0 16px",
      "@media (max-width: 359px)": { padding: "0 10px" },
      "@media (min-width: 1200px)": { padding: "0 28px" },
    },
    toolbar: {
      alignItems: "center",
      minHeight: "68px",
      display: "flex",
      "@media (min-width: 1200px)": { minHeight: "76px" },
      mobile: {
        minHeight: "68px",
        display: "flex",
        alignItems: "center",
      },
    },
    logoLarge: {
      display: "flex",
      width: "126px",
      height: "auto",
      filter: "var(--tezex-logo-filter)",
      flexShrink: 0,
      "@media (max-width: 359px)": { width: "110px" },
      "@media (min-width: 1200px)": { width: "144px" },
    },
    logoLink: {
      display: "flex",
      flexShrink: 0,
      textDecoration: "none",
      outline: "none",
      "&:focus-visible": {
        outline: "none",
        boxShadow: "inset 0 -2px 0 var(--tezex-text-secondary)",
      },
    },
    container: {
      width: "100%",
      alignItems: "center",
      display: "flex",
      gap: "12px",
      "@media (max-width: 359px)": { gap: "8px" },
      "@media (min-width: 1200px)": { gap: "18px" },
    },
    networkSelector: {
      display: "flex",
      alignItems: "center",
      flexShrink: 0,
      "@media (max-width: 519px)": {
        "& > .MuiBox-root": {
          height: "36px",
          minHeight: "36px",
          maxHeight: "36px",
          padding: "0 9px",
          gap: "6px",
          justifyContent: "center",
          borderRadius: "999px",
        },
      },
    },
    nav: {
      display: "none",
      flex: 1,
      justifyContent: "center",
      "@media (min-width: 1200px)": { display: "flex" },
    },
    wallet: {
      display: "none",
      justifyContent: "flex-end",
      "@media (min-width: 1200px)": { display: "flex" },
    },
    actions: {
      display: "flex",
      alignItems: "center",
      justifyContent: "flex-end",
      marginLeft: "auto",
      gap: "8px",
      flexShrink: 0,
      "@media (min-width: 1200px)": { marginLeft: 0, gap: "10px" },
    },
    themeToggle: {
      position: "relative",
      width: "60px",
      height: "36px",
      minHeight: "36px",
      maxHeight: "36px",
      padding: "0 8px",
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      flexShrink: 0,
      color: "var(--tezex-muted)",
      background: "var(--tezex-panel)",
      border: "1px solid var(--tezex-line)",
      borderRadius: "999px",
      cursor: "pointer",
      transition:
        "background-color 180ms ease, border-color 180ms ease, color 180ms ease",
      "&:hover": {
        color: "var(--tezex-text)",
        borderColor: "var(--tezex-line-strong)",
      },
      "&:focus-visible": {
        outline: "2px solid var(--tezex-text-secondary)",
        outlineOffset: "-3px",
      },
    },
    themeIcon: {
      position: "relative",
      zIndex: 1,
      width: "14px",
      height: "14px",
      pointerEvents: "none",
    },
    themeToggleKnob: {
      position: "absolute",
      zIndex: 2,
      top: "2px",
      left: "2px",
      width: "32px",
      height: "32px",
      background: "var(--tezex-action)",
      borderRadius: "50%",
      boxShadow: "0 2px 8px rgba(0, 0, 0, 0.18)",
      pointerEvents: "none",
      transition: "transform 240ms cubic-bezier(.3,.8,.3,1)",
      "@media (prefers-reduced-motion: reduce)": { transition: "none" },
    },
    hide: {
      display: "none",
    },
    menu: {
      display: "flex",
      justifyContent: "flex-end",
      flexShrink: 0,
      "@media (min-width: 1200px)": { display: "none" },
    },
    menuButton: {
      width: "36px",
      height: "36px",
      minWidth: "36px",
      minHeight: "36px",
      maxWidth: "36px",
      maxHeight: "36px",
      color: "var(--tezex-text)",
      border: "1px solid var(--tezex-line)",
      borderRadius: "999px",
      "&:hover": {
        background: "var(--tezex-hover)",
        borderColor: "var(--tezex-line-strong)",
      },
      "&.Mui-focusVisible": {
        outline: "2px solid var(--tezex-text-secondary)",
        outlineOffset: "-3px",
      },
    },
  };
};

export default style;
